import gql from 'graphql-tag';
import ApolloClient from 'apollo-boost';
import { get as _get } from 'lodash-es';

// TODO only run this code if Magento is the active platform
// TODO: Get rid of Apollo/graphql-tag dependency to remove the 34.15KB (gzipped) penalty

const Magento = {
  getProductsBySkus: function(
    merchantProductSkus,
    returnProductDataCallback,
    errorCallback
  ) {
    const client = new ApolloClient({
      uri: window.compatioConfig.magento.apiEndpointUrl,
    });

    // TODO: Eventually pass this array in via a "variables" object to the client.query method. Initial attempts to do this were unsuccessful.
    const merchantProductSkusString = JSON.stringify(merchantProductSkus);

    client
      .query({
        query: gql`
{
  products(
    filter: {
      sku: {
        in: ${merchantProductSkusString}
      }
    }
    pageSize: 100000
  )
  {
    total_count
    items {
      sku
      name
      small_image {
        label
        url
      }
      url_key
      stock_status
      price {
        regularPrice {
          amount {
            value
            currency
          }
        }
      }
    }
    page_info {
      page_size
      current_page
    }
    sort_fields {
      options {
        value
        label
      }
    }
  }
}
      `,
      })
      .then(
        result => {
          returnProductDataCallback(
            Magento.convertGraphQLToCompatioFormat(result)
          );
        },
        rejected => {
          console.error(rejected);
          errorCallback();
        }
      );
    // TODO: how to filter out "disabled" or "not visible" products (see https://devdocs.magento.com/guides/v2.3/graphql/reference/products.html#info)
  },

  convertGraphQLToCompatioFormat: function(graphQLData) {
    const products = graphQLData.data.products.items.map(data => {
      return {
        merchantProductSku: data.sku,
        parentProductId: data.sku,
        productName: data.name,
        variantName: data.name,
        url_image: data.small_image.url,
        url_product:
          _get(window.compatioConfig, 'magento.baseUrl', '') +
          data.url_key +
          _get(window.compatioConfig, 'magento.urlSuffix', ''),
        price: this.getMagentoPrice(data.price),
        currency: this.getMagentoCurrency(data.price),
      };
    }, this);

    return { data: products };
  },

  getMagentoPrice: priceObject => {
    return parseFloat(_get(priceObject, 'regularPrice.amount.value', 'error'));
  },

  getMagentoCurrency: priceObject => {
    return _get(priceObject, 'regularPrice.amount.currency', 'USD');
  },
};

if (typeof _get(window, 'compatioConfig') !== 'object') {
  window.compatioConfig = {};
}

if (typeof _get(window, 'compatioConfig.compatibleProducts') !== 'object') {
  window.compatioConfig.compatibleProducts = {};
}

if (
  typeof _get(window, 'compatioConfig.compatibleProducts.callbacks') !==
  'object'
) {
  window.compatioConfig.compatibleProducts.callbacks = {};
}

// If function is already defined, don't override it
if (
  typeof _get(
    window,
    'compatioConfig.compatibleProducts.callbacks.getProductsBySkus'
  ) === 'undefined' &&
  typeof _get(window, 'compatioConfig.magento') !== 'undefined'
) {
  window.compatioConfig.compatibleProducts.callbacks.getProductsBySkus =
    Magento.getProductsBySkus;
}

// TODO: Refactor this to avoid using globals
window.compatioMagento = Magento;

export default Magento;
